<div class="content-container">
    @if (permissions.canImpersonate) {
    <mat-card appearance="outlined">
        <mat-card-header>
            <mat-card-title>
                <mat-icon>security</mat-icon>
                Impersonation
            </mat-card-title>

        </mat-card-header>
        <mat-card-content>
            <p>
                You may impersonate a user by entering parts of their name or Hawk Id below.
            </p>
            <p class="impersonation-searcher">
                <mat-form-field>
                    <mat-label>Hawk Id to Impersonate</mat-label>
                    <input matInput [matAutocomplete]='impauto' [formControl]="impersonatedHawkId" />
                    @if (impersonatedHawkId.value) {
                    <button matSuffix mat-icon-button aria-label="Clear" (click)="impersonatedHawkId.setValue('')">
                        <mat-icon>close</mat-icon>
                    </button>
                    }
                    <mat-autocomplete #impauto autoActiveFirstOption [displayWith]="displayUserWith">
                        @for (user of impersonationOptions | async; track user) {
                        <mat-option [value]="user">
                            {{ user.displayName }} ({{ user.hawkId }})
                        </mat-option>
                        }
                    </mat-autocomplete>
                </mat-form-field>
                <button matButton mat-raised-button (click)="beginImpersonation()">Begin Impersonation</button>
            </p>
            <p>
                <b>Status:</b> You are {{ auth.isImpersonating ? auth.applicationUsername : "you" }}.
                @if (auth.isImpersonating) {
                <a [routerLink]="['.']" (click)="endImpersonation()">End Impersonation</a>
                }
            </p>
            <p class="note">
                <mat-icon>warning</mat-icon>
                <span>
                    Please remember: after beginning impersonation, all actions you take, <b>including changing settings on
                        this page or changing a timesheet</b>, will
                    be done as that user until you end impersonation. A record will be kept of the impersonation session.
                </span>
            </p>
        </mat-card-content>
    </mat-card>
    }

    <mat-card appearance="outlined">
        <mat-card-header>
            <mat-card-title>
                <mat-icon>settings</mat-icon>
                Timesheet
            </mat-card-title>

        </mat-card-header>
        <mat-card-content>
            <form [formGroup]="general">
                <div class="widget-set">
                    <div style="font-weight: bold;">General</div>
                    <p class="basics">
                        <mat-checkbox formControlName="showTimesheetHelper">Show timesheet helper message.</mat-checkbox>
                        <mat-checkbox formControlName="confirmTSSubmit">Ask confirmation when submitting timesheets.</mat-checkbox>
                        <mat-checkbox formControlName="enableColTools">Enable column tools (cut, copy, paste).</mat-checkbox>
                        <mat-checkbox formControlName="enableRowTools">Enable row tools (cut, copy, paste).</mat-checkbox>
                    </p>
                </div>
                <div class="widget-set">
                    <div style="font-weight: bold">Default Week</div>
                    <span class='question-info'>When first logging in, which timesheet should load by default?</span>
                    <mat-radio-group name="ts-week" formControlName="defaultTimesheetWeek">
                        <mat-radio-button value="current-week">The current week's.</mat-radio-button>
                        <mat-radio-button value="last-opened">The last one I had open.</mat-radio-button>
                        <mat-radio-button value="oldest-unsubmitted">The oldest unsubmitted of the past 6 weeks.</mat-radio-button>
                    </mat-radio-group>
                </div>
                <!-- <div class="widget-set">
                    <span class="question-info">Timers</span>
                    <p>
                        <mat-checkbox formControlName="allowPersistedTimers">Allow timers to persist across sessions.<sup>1</sup></mat-checkbox>
                    </p>
                </div> -->
                <!-- <div class="days-off widget-set">
                    <span class='question-info'>My days off</span>
                    @for (d of days; track d; let i = $index) {
                    <ng-container formArrayName="daysOff">
                        <mat-checkbox [formControlName]="i">{{d | titlecase }}</mat-checkbox>
                    </ng-container>
                    }
                </div> -->
                <!-- <div class="rounding widget-set">
                    <span class="question-info">Time entry</span>
                    <mat-checkbox formControlName="allowTwoDigitEntry">Allow two-digits of precision when
                        entering time:</mat-checkbox>
                    <mat-form-field>
                        <mat-label>Rounding</mat-label>
                        <mat-select formControlName="hoursRoundingMethod" required>
                            <mat-option value="down">Round down, so 0.25 &rarr; 0.2.</mat-option>
                            <mat-option value="up">Round up, so 0.25 &rarr; 0.3.</mat-option>
                            <mat-option value="nearest">Round nearest.</mat-option>
                        </mat-select>
                    </mat-form-field>
                    <span class="hint">Please be advised that HR systems only store and use hours at one digit of precision. Many groups don't require even that much.</span>
                </div> -->
                <!-- <div class="widget-set" style="margin-top: 3em; font-style: italic;">
                    <span class="quesion-info">Footnotes</span>
                    <ol>
                        <li>A persisted timer saves updates only while you are logged.
                            <b>Example:</b> starting a timer today at 5pm, logging out, then logging back in at 5am would
                            save 12 hours tomorrow morning but nothing in the intervening hours.
                        </li>
                        <li>Please be advised that HR systems only store and use hours at one digit of precision. Many
                            groups don't require even that much.</li>
                    </ol>
                </div> -->
            </form>
        </mat-card-content>
    </mat-card>

    @if(permissions.hasReports) {
    <!-- <mat-card appearance="outlined">
        <mat-card-header>
            <mat-card-title>
                <mat-icon>report</mat-icon>
                Submissions
            </mat-card-title>

        </mat-card-header>
        <mat-card-content>
            <div class="widget-set">
                <span class='question-info'>"Notify by email" defaults</span>
                <div class="radio-grid">
                    <div>Returns</div>
                    <mat-radio-group class="horizontal">
                        <mat-radio-button value='on'>On</mat-radio-button>
                        <mat-radio-button value='off'>Off</mat-radio-button>
                        <mat-radio-button value='per-user'>Remember last choice for each user</mat-radio-button>
                    </mat-radio-group>
                    <div>Approvals</div>
                    <mat-radio-group class="horizontal">
                        <mat-radio-button value='on'>On</mat-radio-button>
                        <mat-radio-button value='off'>Off</mat-radio-button>
                        <mat-radio-button value='per-user'>Remember last choice for each user</mat-radio-button>
                    </mat-radio-group>
                </div>
            </div>

        </mat-card-content>
    </mat-card> -->
    }

    <mat-card appearance="outlined">
        <mat-card-header>
            <mat-card-title>
                <mat-icon>accessibility</mat-icon>
                Accessibility and User Experience
            </mat-card-title>

        </mat-card-header>
        <mat-card-content>
            <form [formGroup]="access_and_ux">
                <div class="widget-set">
                    <div style="font-weight: bold;">Persistent Buttons</div>
                    <span class='question-info'>Should icon buttons display persistently, or only when hovering (e.g.,
                        project
                        pinning in the timesheet)?</span>
                    <mat-radio-group name="icon-btn-persistence" formControlName="iconBtnPersistence">
                        <mat-radio-button value="persistent">Use persistent icons where possible.</mat-radio-button>
                        <mat-radio-button value="transient">Show some icons only on hover (default, saves screen real
                            estate).</mat-radio-button>
                    </mat-radio-group>
                </div>
                <div class="widget-set">
                    <div style="font-weight: bold">Cell Tools</div>
                    <span class='question-info'>Where should cell tools like the timer and notes be available (in
                        addition to the hotkeys)?</span>
                    <mat-radio-group name="ts-cell-tool-location" formControlName="tsCellToolLocation">
                        <mat-radio-button value="context-menu">In the right-click context menu.</mat-radio-button>
                        <mat-radio-button value="active-bottom">As buttons below the currently-focused
                            cell.</mat-radio-button>
                        <mat-radio-button value="persistent-right">As buttons available in every cell.</mat-radio-button>
                    </mat-radio-group>
                </div>
                <div class="widget-set">
                    <div style="font-weight: bold;">Dark Mode</div>
                    <span class="question-info">How do you want us to manage dark mode across your devices?</span>
                    <mat-radio-group name="dark-mode-persistence" formControlName="darkModePersistence">
                        <mat-radio-button value="api">Use a TKS-stored global setting for all devices.</mat-radio-button>
                        <mat-radio-button value="">Store nothing. When the browser or device's light/dark setting changes, so will this page. <b>Current setting: '{{theme.deviceLightDarkSetting}}'.</b></mat-radio-button>
                        <mat-radio-button value="local">Use a browser-stored setting for each device or browser.</mat-radio-button>
                    </mat-radio-group>
                </div>
            </form>
        </mat-card-content>
    </mat-card>

    <div class="wait-for-prefs" [class.shown]="loading">
        <mat-spinner></mat-spinner>
    </div>
</div>